import i18n from 'src/lib/i18n/i18n';

export function PayButton({
  disabled,
  loading,
  onClick,
}: {
  disabled?: boolean;
  loading?: boolean;
  onClick: (event: Event) => void;
}) {
  return (
    <div class="payButtonArea">
      <input
        type="submit"
        class="payButton"
        disabled={disabled}
        value={loading ? ' ' : i18n('komojuHostedFields.submit')}
        onClick={onClick}
      />
      {loading && (
        <div class="lds-ring" style={{ marginTop: '-3rem' }}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      )}
    </div>
  );
}
